import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
      console.log("Service worker removed:", registration);
    });
  });
}

// Prevent infinite reload loops
let hasReloaded = false;

window.addEventListener("error", (event) => {
  if (
    !hasReloaded &&
    (event?.message?.includes("Loading chunk") ||
      event?.message?.includes("ChunkLoadError"))
  ) {
    hasReloaded = true;
    console.log("Chunk load error detected. Reloading once...");
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
